import axios from "../../../../api/axios";
import { Post } from "../../../Feeds/types/post.type";

export enum ActivityType {
  all = "ALL",
  posts = "BASIC",
  challenges = "CHALLENGE",
  events = "EVENT",
  review = "REVIEW",
  service = "SERVICE",
  program = "PROGRAM",
}

export const ACTIVITY_TYPES = [
  ActivityType.all,
  ActivityType.posts,
  ActivityType.events,
  ActivityType.service,
  ActivityType.program,
  ActivityType.challenges,
];

interface GetUserActivitiesParams {
  limit: number;
  offset: number;
  type?: ActivityType;
}

export interface UserActivitiesResponse {
  items: Post[];
  total: number;
  mentionedUsers: number[];
}

const ACTIVITIES_PAGE_LIMIT = 2;

export const getUserActivities = async (
  userId: string,
  offset: number,
  activityType?: ActivityType
): Promise<UserActivitiesResponse> => {
  const params: GetUserActivitiesParams = {
    limit: ACTIVITIES_PAGE_LIMIT,
    offset,
  };

  if (activityType && activityType !== ActivityType.all) {
    params.type = activityType;
  }

  const response = await axios.get(`/users/${userId}/activities/basic-post`, {
    params,
  });

  return response.data.data;
};
